export default "__VITE_ASSET__C4h9Dd3q__"